import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

const defaultOptions = {
  autoplay: 1,
  controls: 1,
  rel: 0,
};

export default function VimeoEmbed(props) {
  const { title, videoId, ...embedOptions } = props;

  const videoPlayerParams = qs.stringify(
    { ...defaultOptions, ...embedOptions },
    { addQueryPrefix: true },
  );

  return (
    <iframe
      src={`https://player.vimeo.com/video/${videoId}${videoPlayerParams}`}
      title={title}
      allowFullScreen
      allow="autoplay; fullscreen; picture-in-picture;"
      frameBorder="0"
    />
  );
}

VimeoEmbed.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string,
};
